import { render, staticRenderFns } from "./ClassListDesktop.vue?vue&type=template&id=377d526a&"
import script from "./ClassListDesktop.vue?vue&type=script&lang=js&"
export * from "./ClassListDesktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports